import {getServices} from '../services/taxonomy';

export const actions = {
  FETCH_PENDING: 'TAXONOMY::FETCH_PENDING',
  FETCH_FULFILLED: 'TAXONOMY::FETCH_FULFILLED',
  FETCH_REJECTED: 'TAXONOMY::FETCH_REJECTED',
};

export function fetchServiceTaxonomy() {
  return dispatch => {
    dispatch({type: actions.FETCH_PENDING});

    return getServices()
      .then(data => {
        return dispatch({type: actions.FETCH_FULFILLED, payload: data});
      })
      .catch(err => {
        dispatch({
          type: actions.FETCH_REJECTED,
          payload: {
            error: {
              title: 'Unable to fetch services',
              message: err.message,
            },
          },
        });
      });
  };
}
